import clsx from 'clsx';
import { motion } from 'framer-motion';
import { OfferSettings } from './OfferSettings';
import Divider from 'components/Divider/Divider';
import { ProductOfferingType } from 'screens/SelectServices/schemas';
import { useSingleServiceManager } from 'context/SingleServiceManagerContext';
import { StarlinkOfferSettings } from './StarlinkOfferSettings';
import Skeleton from 'components/Skeleton/Skeleton';

interface AccessCustomizableOptionsProps {
  data: {
    address: string;
    id: string;
    offerings: ProductOfferingType[];
    type?: string;
  };
}

const AccessCustomizableOptions = ({
  data,
}: AccessCustomizableOptionsProps) => {
  const { pinnedServices, isUnpinning } = useSingleServiceManager();
  return (
    <div className="relative flex h-full flex-row overflow-hidden rounded rounded-t-none border border-t-0 border-[#47556980] bg-background-base-surface-1">
      {data.type === 'starlink' ? (
        <StarlinkOfferSettings data={data} />
      ) : (
        <OfferSettings data={data} />
      )}

      <div className="!my-6 mx-4 hidden sm:block">
        <Divider layout="vertical" className="h-full" variant="dotted" />
      </div>
      {pinnedServices[`${data.id}_${data.type}`] ? (
        <div
          className={clsx(
            'relative flex w-1/2 flex-col rounded outline-none outline outline-1 transition-all',
            isUnpinning ? 'animate-poof' : 'animate-slide-in-left-to-right',
          )}
        >
          {data.type === 'starlink' ? (
            <StarlinkOfferSettings data={data} isPinnedSummary={true} />
          ) : (
            <OfferSettings data={data} isPinnedSummary={true} />
          )}
        </div>
      ) : (
        <div className="w-0 sm:w-1/2" />
      )}
      <motion.div
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        className="pointer-events-none absolute inset-0 z-50 bg-background-base-surface-1"
      >
        <Skeleton
          className="!bg-neutral-50 absolute inset-6 rounded-sm opacity-5"
          animate={false}
        />
      </motion.div>
    </div>
  );
};
const variants = {
  initial: {
    opacity: 1,
    transition: { delay: 0.5, duration: 0.5 },
  },
  animate: {
    opacity: 0,
    transition: { delay: 1, duration: 0.5, ease: 'easeInOut' },
  },
  exit: {
    opacity: 1,
    transition: { delay: 0, duration: 0.5, ease: 'easeInOut' },
  },
};

export default AccessCustomizableOptions;
